var _effectorFileName = "/builds/gmini/front-ui-kit/src/UserProfile/UserProfile.tsx";

/* eslint-disable react/display-name */
import React, { useState } from 'react';
import { MenuItem, ListItemIcon } from '@mui/material';
import { useSnackbar } from 'notistack';
import { Avatar } from '../icons/Avatar';
import { Support, Exit, Confluence } from '../icons';
import { Snackbar } from '../Snackbar';
import { IconContainer, IconWrap, StyledLink, UserProfileWrap, UserTitle, Menu } from './UserProfile.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const UserProfile = ({
  userName,
  email,
  onLogout,
  onProfileClick
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [hover, setHover] = useState(false);
  const {
    enqueueSnackbar,
    closeSnackbar
  } = useSnackbar();
  const handleClose = React.useCallback(() => {
    setAnchorEl(null);
  }, []);
  const onLogoutClick = React.useCallback(() => {
    setAnchorEl(null);
    onLogout();
  }, [onLogout]);

  const onProfileClickHandler = event => {
    setAnchorEl(event.currentTarget);
    onProfileClick === null || onProfileClick === void 0 ? void 0 : onProfileClick();
  };

  const onClickSupport = () => {
    navigator.clipboard.writeText('gssupport@fsk.ru');
    enqueueSnackbar('', {
      content: key => /*#__PURE__*/_jsx(Snackbar, {
        "data-test-id": "copySupportEmail",
        id: key,
        message: "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
        onClose: () => closeSnackbar(key)
      }),
      variant: 'info'
    });

    if (email !== null && email !== void 0 && email.includes('@fsk.')) {
      window.open('https://sd.fsk.ru/', '_blank');
    }

    handleClose();
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UserProfileWrap, {
      onClick: onProfileClickHandler,
      "data-test-id": "user_menu",
      onMouseOver: () => setHover(true),
      onMouseLeave: () => setHover(false),
      children: [/*#__PURE__*/_jsx(UserTitle, {
        hover: hover || !!anchorEl,
        children: userName
      }), /*#__PURE__*/_jsx(IconContainer, {
        children: /*#__PURE__*/_jsx(IconWrap, {
          hover: hover || !!anchorEl,
          children: /*#__PURE__*/_jsx(Avatar, {
            width: "100%",
            height: "100%"
          })
        })
      })]
    }), /*#__PURE__*/_jsxs(Menu, {
      anchorEl: anchorEl,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      open: Boolean(anchorEl),
      onClose: handleClose,
      autoFocus: false,
      children: [/*#__PURE__*/_jsxs(MenuItem, {
        "data-test-id": "openSupport",
        onClick: onClickSupport,
        children: [/*#__PURE__*/_jsx(ListItemIcon, {
          children: /*#__PURE__*/_jsx(Support, {})
        }), "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u0442\u0435\u0445. \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443"]
      }), /*#__PURE__*/_jsxs(MenuItem, {
        "data-test-id": "openConfluence",
        component: StyledLink,
        target: "_blank",
        href: "https://gmini.atlassian.net/wiki/spaces/HDKBpIGAwbbP/overview?homepageId=727056622",
        onClick: handleClose,
        children: [/*#__PURE__*/_jsx(ListItemIcon, {
          children: /*#__PURE__*/_jsx(Confluence, {})
        }), "\u0411\u0430\u0437\u0430 \u0437\u043D\u0430\u043D\u0438\u0439"]
      }), /*#__PURE__*/_jsxs(MenuItem, {
        onClick: onLogoutClick,
        "data-test-id": "logout",
        children: [/*#__PURE__*/_jsx(ListItemIcon, {
          children: /*#__PURE__*/_jsx(Exit, {})
        }), "\u0412\u044B\u0439\u0442\u0438"]
      })]
    })]
  });
};